import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

//----- store
import { fetchQCardData } from "../../store/qCardCompletedCourses-actions";

import IconHat from "../../assets/img/icons/hat.svg";

import LoadingSpinner from "../UI/LoadingSpinner/LoadingSpinner";

import Styles from "./QCardCompletedCourses.module.css";

const QCardCompletedCourses = (props) => {
	const dispatch = useDispatch();

	const isLoading = useSelector((state) => state.uiData.isLoading[0]);

	const qCardCompletedCoursesData = useSelector(
		(state) => state.qCardCompletedCoursesData
	);
	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const apiConfigData = useSelector((state) => state.apiConfigData);

	const url_data =
		apiConfigData.endpoint.domain +
		apiConfigData.endpoint.dashboard.completedCourses;

	useEffect(() => {
		dispatch(fetchQCardData(url_data, autenticationData));
	}, [dispatch]);

	useEffect(() => {
		// console.log("qCardCompletedCoursesData", qCardCompletedCoursesData);
	}, [qCardCompletedCoursesData]);

	return (
		<div className={Styles["QCardCompletedCourses"]}>
			<div className="row">
				<div className={`col-xs-12 ${Styles["title"]}`}>
					{props.title}
				</div>
			</div>
			{isLoading && (
				<div style={{ textAlign: "center" }}>
					<LoadingSpinner />
				</div>
			)}
			{!isLoading && (
				<div className={`row ${Styles["row"]}`}>
					<div className="col-xs-6">
						<span className={Styles["counter"]}>
							{qCardCompletedCoursesData.value}
						</span>
					</div>
					<div className="col-xs-6">
						<span className={Styles["icon-container"]}>
							<img
								src={IconHat}
								className={Styles["icon"]}
								alt=""
							/>
						</span>
					</div>
				</div>
			)}
		</div>
	);
};

export default QCardCompletedCourses;
